/**
 * Generic modal interface, used for drawers, navigation and modals.
 */

import { dialog, domapi } from '@rynpsc/dialog';

export function init() {
	domapi.mount();

	Array.from(document.querySelectorAll('.js-modal')).forEach(element => create(element));
}

function create(element) {
	let instance = dialog(element.id);
	let contentElement = element.querySelector('.js-modal-content');

	if (instance) {
		instance.create();

		instance.on('open', () => {
			loadFormScript(instance);

			element.scrollTop = 0;

			let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

			document.body.style.overflow = 'hidden';
			document.body.style.paddingRight = `${scrollbarWidth}px`;
			document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
		});

		instance.on('close', () => {
			instance.element.addEventListener('transitionend', onTransitionEnd);
		});

		instance.element.addEventListener('click', event => {
			if (!contentElement || contentElement.contains(event.target)) {
				return;
			}

			instance.close();
		}, true);
	}

	function onTransitionEnd(event) {
		if (event.propertyName !== 'opacity') {
			return;
		}

		document.body.style = '';
		document.body.style.paddingRight = '';
		document.documentElement.style.setProperty('--scrollbar-width', '');

		instance.element.removeEventListener('transitionend', onTransitionEnd);
	}
}

function loadFormScript(instance) {
	let element = instance.element;
	let target = element.querySelector('[data-modal-script]');

	if (!target) {
		return;
	}

	let script = document.createElement('script');

	script.type = 'text/javascript';
	script.src = target.dataset.modalScript;

	element.appendChild(script);
}
